import type { MfoDealOffer, TMfoDealViewModel } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

export const getAnalyticsMfoDealOfferParams = (deal: TMfoDealViewModel, offer: MfoDealOffer) => {
  const summariesMap = (offer.summaries || []).reduce<Record<string, NonNullable<typeof offer.summaries>[0]>>(
    (acc, summary) => {
      acc[summary.label] = summary;
      return acc;
    },
    {},
  );

  return {
    offerType: 'MFO',
    productName: deal.dealCardTitle || offer.type || '',
    productId: offer.offerId,
    organizationId: deal.organizationId,
    organizationName: deal.organizationName,
    offerIndex: deal.order,
    badges: (offer.badges || []).map((badge) => badge.title).join(' '),
    status: deal.status,
    psk: summariesMap.LoanPsk?.value?.toString() ?? '',
    sum: summariesMap.LoanAmount?.value?.toString() ?? offer.amount?.toString() ?? '',
    rate: summariesMap.LoanRate?.value?.toString() ?? offer.interestRate?.toString() ?? '',
    term: summariesMap.LoanTerm?.value?.toString() ?? offer.termValue?.toString() ?? '',
  };
};
